import React from 'react';
import ProjectDetailView from 'components/ProjectDetailView/ProjectDetailView';
import hikingHouseData from './data';

const HikingHouse = () => {
  return <ProjectDetailView data={hikingHouseData} />;
};

export default HikingHouse;
